import { useImpression } from '@thd-olt-component-react/impression';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useBreakpoint } from '@one-thd/sui-atomic-components';
import {
  getOrientationType,
  getImageAndTextWidthClasses,
  getTextPaddingClasses,
  getLeftSpaceClasses
} from '../components/utils/helpers';
import { normalizeNewspaperData } from '../components/utils/normalizeNewspaperData';

export const useNewspaper = ({
  id,
  slotName,
  componentClass,
  livePreviewData = null,
  slotData,
  mediaCollectionIndex = 0
}) => {
  // Legacy dataModel call - skip if slotData is provided (new fusion pattern)
  const { data: componentData } = useDataModel('component', {
    variables: {
      id,
      componentClass
    },
    skip: !!slotName // Skip if slotData exists (fusion pattern)
  });
  const { lesser: isMobileViewport } = useBreakpoint('lg', { ssr: true });

  // Normalize data from different sources
  const normalizedData = normalizeNewspaperData({
    slotData,
    componentData,
    mediaCollectionIndex,
    isMobileViewport
  });

  const dataComponent = livePreviewData || normalizedData;
  const description = dataComponent?.description || '';

  // Handle richText based on source
  let richText = '';
  if (livePreviewData) {
    // Live preview: description is an object with json property
    richText = description?.json;
  } else if (typeof description === 'string') {
    // Legacy component data: description is already a string
    richText = description;
  }

  // Set up impression tracking
  const {
    ref,
    clickID
  } = useImpression({
    data: {
      id: dataComponent?.entryId || id || '',
      name: 'NewspaperModule',
      component: 'NewspaperModule',
      position: 1,
      type: 'content'
    }
  });

  // If no data is available, return early
  if (!dataComponent) {
    return { hasData: false };
  }

  const damImageWidthBehavior = dataComponent?.damImageWidthBehavior;
  const descriptionAlignment = dataComponent?.descriptionAlignment;

  const { isCentered, isVertical, imageFirst } = getOrientationType(
    dataComponent?.damImageAlignmentBehavior,
    descriptionAlignment,
    richText
  );

  const { imageWidthClasses, textWidthClasses } = getImageAndTextWidthClasses(damImageWidthBehavior, isVertical);
  const textPaddingClasses = getTextPaddingClasses(descriptionAlignment);
  const leftSpaceClasses = getLeftSpaceClasses({ isVertical, isCentered, damImageWidthBehavior });

  return {
    hasData: true,
    ref,
    clickID,
    imageRenderObj: {
      link: dataComponent?.link,
      altText: dataComponent?.altText,
      mobilePreviewImage: dataComponent?.mobileImage,
      previewImage: dataComponent?.desktopImage,
      imageWidthClasses,
      leftSpaceClasses,
      imageFirst,
    },
    richTextObj: {
      textWidthClasses,
      textPaddingClasses,
      richText,
      imageFirst
    },
    sourceData: dataComponent?.sourceData
  };
};